// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3ESC4","title":"InfoRow_title__1Y9Os"};